import StoryCreate from './StoryCreate';
import StoryEdit from './StoryEdit';

export default {
    create: StoryCreate,
    edit: StoryEdit,
};
